var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button-vue',_vm._b({class:_vm.className,attrs:{"copy":_vm.copy,"href":_vm.href,"event-category":_vm.eventCategory,"event-name":_vm.plan.type,"is-cta":true}},'button-vue',_vm.dataAttributes,false))}
var staticRenderFns = []

export { render, staticRenderFns }